import module from 'recursoshumanos/module.js'
import * as moment from 'moment'
import { isArray } from 'lodash'

const Page = (data, encabezados, nombre) => {
  return {
    name: nombre,
    columns: encabezados,
    options: {
      logo: {
        filename: '/api/export/images/FAN-logo.png',
        title: 'FAN Consultores',
        cell: 'A1',
      },
      show_grid: false,
      fixed_column: 'A8',
    },
    data: data,
  }
}

export class RecursoshumanosVisorlotesService {
  constructor ($http, $api, $export, $schema) {
    this.$http = $http
    this.$api = $api
    this.$schema = $schema
    this.$export = $export
  }

  exportarMasivoExcel ({fecha, idEmpresa, clase, proyectos, tipoMovimientoId, registroPatronalId}) {
    return this.$http.get('/api/recursos_humanos/masivo_excel', {
      params: {
        fecha: fecha && moment(fecha).format('YYYY-MM-DD') || undefined,
        operadora_id: idEmpresa,
        clase: clase,
        registroPatronalId,
        proyectos: (isArray(proyectos) && proyectos.join()) || undefined,
        tipo_movimiento: tipoMovimientoId,
      },
    }).then((response) => {
      return this.exportarXLS(response.data, 'masivo', 'masivo')
    })
  }

  exportarXLS (data, Numero_Lote, Numero_FolioDocumento) {
    let pages = [],
      encabezados =
        [
          {label: 'NSS', format: {align: 'left', width: 20}},
          {label: 'RFC', format: {align: 'left', width: 20}},
          {label: 'CURP', format: {align: 'left', width: 20}},
          {label: 'Primer Apellido', format: {align: 'left', width: 40}},
          {label: 'Segundo Apellido', format: {align: 'left', width: 40}},
          {label: 'Nombre(s)', format: {align: 'left', width: 40}},
          {label: 'Tipo de Trabajador', format: {align: 'center', width: 10}},
          {label: 'T_Sal', format: {align: 'center', width: 10}},
          {label: 'Sueldo Base', format: {type: 'currency', align: 'right', width: 20}},
          {label: 'Fecha de Movimiento', format: {align: 'center', width: 20}},
          {label: 'Número de Empleado Kendu', format: {align: 'center', width: 10}},
          {label: 'Tipo Moviento', format: {align: 'center', width: 10}},
          {label: 'ID EX', format: {align: 'center', width: 10}},
          {label: 'UMF', format: {align: 'center', width: 10}},
          {label: 'Clave Baja ', format: {align: 'center', width: 10}},
          {label: 'ID_Empresa', format: {align: 'left', width: 10}},
          {label: 'Empresa', format: {align: 'left', width: 40}},
          {label: 'Nombre en Archivo IDSE', format: {align: 'left', width: 40}},
          {label: 'Coincidencia Nombre', format: {align: 'center', width: 10}},
          {label: 'Coincidencia Número de IMSS', format: {align: 'center', width: 10}},
          {label: 'Coincidencia Salario', format: {align: 'center', width: 10}},
          {label: 'Coincidencia Status', format: {align: 'center', width: 10}},
        ]
    pages.push(new Page(data, encabezados, Numero_Lote))
    this.$export.excel('IDSE_' + Numero_FolioDocumento + '_Lote_' + Numero_Lote, pages)
  }
}

module.service('RecursoshumanosVisorlotesService', RecursoshumanosVisorlotesService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/VisorLotesService.js